import * as yup from "yup";

export const loginSchema = yup.object().shape({
  phone: yup
    .string()
    .matches(/^(\+[0-9]{1,4})?[0-9]{10}$/, "Invalid Phone Number")
    .required("Phone is required")
});
